// extracted by mini-css-extract-plugin
module.exports = {"MainContainer":"TaskCard_MainContainer__249ZY","TaskLabelWrapper":"TaskCard_TaskLabelWrapper__1AdV9","Message":"TaskCard_Message__35zIp"};